import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";

function FaqList() {
  const [faqs, setFaqs] = useState([]);
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const fetchFaqs = async () => {
    try {
      const res = await axios.get(process.env.REACT_APP_API_URL +"/admin/faqs", {
        headers: { Authorization: `Bearer ${token}` },
        });
      setFaqs(res.data);
    } catch (err) {
      console.error(err);
      if (err.response?.status === 401) navigate("/admin/login");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this FAQ?")) return;
    try {
      await axios.delete(`${process.env.REACT_APP_API_URL}/faqs/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      fetchFaqs();
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchFaqs();
  }, []);

  return (
    <div className="container py-5">
      <h2 className="mb-4">Manage FAQs</h2>
      <Link to="/admin/faqs/new" className="btn btn-success mb-3">Add New FAQ</Link>

      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Question</th>
            <th>Category</th>
            <th>Published</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {faqs.map((faq) => (
            <tr key={faq.id}>
              <td>{faq.question}</td>
              <td>{faq.category_name}</td>
              <td>{faq.published ? "Yes" : "No"}</td>
              <td>
                <Link className="btn btn-primary btn-sm me-2" to={`/admin/faqs/edit/${faq.id}`}>Edit</Link>
                <button className="btn btn-danger btn-sm" onClick={() => handleDelete(faq.id)}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default FaqList;
